"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
exports.createMuiButtonOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions, typography = _a.typography;
    return ({
        root: {
            minWidth: spacing(8),
            minHeight: spacing(8),
            padding: spacing(1, 4),
            transition: transitions.create(["background-color", "border-color", "opacity"], { duration: transitions.duration.short }),
            "&:hover": {
                backgroundColor: undefined,
            },
            "&$disabled": {
                color: undefined,
                opacity: palette.action.disabledOpacity,
            },
        },
        focusVisible: {
            "&$contained, &$text": {
                boxShadow: "inset 0 0 0 1px " + palette.text.primary,
            },
        },
        contained: {
            "&:active": {
                opacity: 1 - palette.action.activatedOpacity,
            },
            "&$disabled": {
                color: undefined,
                backgroundColor: undefined,
            },
        },
        containedPrimary: {
            "&:hover": {
                backgroundColor: colorManipulator_1.lighten(palette.primary.main, palette.action.hoverOpacity),
            },
            "&:active": {
                backgroundColor: palette.primary.main,
            },
            "&$focusVisible": {
                backgroundColor: colorManipulator_1.lighten(palette.primary.main, palette.action.focusOpacity),
            },
        },
        containedSecondary: {
            "&:hover": {
                backgroundColor: colorManipulator_1.lighten(palette.secondary.main, palette.action.hoverOpacity),
            },
            "&:active": {
                backgroundColor: palette.secondary.main,
            },
            "&$focusVisible": {
                backgroundColor: colorManipulator_1.lighten(palette.secondary.main, palette.action.focusOpacity),
            },
        },
        // TODO: Phase out outlined buttons
        outlined: {
            // Default, minus border thickness
            padding: spacing(1) - 1 + "px " + (spacing(4) - 1) + "px",
            "&$disabled": {
                border: undefined,
            },
            "&&$focusVisible": {
                boxShadow: "inset 0 0 0 1px " + palette.text.secondary,
            },
        },
        outlinedPrimary: {
            border: undefined,
            borderColor: palette.primary.main,
            color: palette.text.primary,
            "&:hover": {
                border: undefined,
                backgroundColor: colorManipulator_1.fade(palette.primary.main, palette.action.hoverOpacity),
            },
            "&:active": {
                backgroundColor: colorManipulator_1.fade(palette.primary.main, palette.action.selectedOpacity),
            },
            "&&$focusVisible": {
                borderColor: undefined,
                backgroundColor: colorManipulator_1.fade(palette.primary.main, palette.action.focusOpacity),
            },
        },
        outlinedSecondary: {
            border: undefined,
            borderColor: palette.divider,
            color: palette.secondary.contrastText,
            "&:hover": {
                border: undefined,
                backgroundColor: palette.action.hover,
            },
            "&:active": {
                backgroundColor: palette.action.selected,
            },
            "&&$focusVisible": {
                borderColor: undefined,
                backgroundColor: palette.action.hover,
            },
            "&$disabled": {
                border: undefined,
            },
        },
        text: {
            padding: spacing(1, 2),
        },
        textPrimary: {
            color: palette.text.primary,
            "&:hover": {
                backgroundColor: palette.action.hover,
            },
            "&:active": {
                backgroundColor: palette.action.selected,
            },
            "&$focusVisible": {
                backgroundColor: palette.action.hover,
            },
        },
        sizeLarge: {
            minHeight: spacing(12),
        },
        containedSizeLarge: {
            padding: spacing(3, 6),
            fontSize: undefined,
        },
        textSizeLarge: {
            padding: spacing(3),
            fontSize: undefined,
        },
        outlinedSizeLarge: {
            // Default, minus border thickness
            padding: spacing(3) - 1 + "px " + (spacing(6) - 1) + "px",
            fontSize: undefined,
        },
        // Size small will be undocumented now, but we're keeping support
        sizeSmall: {
            minHeight: spacing(6),
            padding: "3px " + spacing(2) + "px",
            "&&": {
                flexGrow: 0,
                fontSize: typography.pxToRem(9),
            },
        },
        outlinedSizeSmall: {
            // Default, minus border thickness
            padding: "2px " + (spacing(2) - 1) + "px",
            fontSize: undefined,
        },
        // Unset other variant specific changes
        containedSizeSmall: { padding: undefined, fontSize: undefined },
        textSizeSmall: { padding: undefined, fontSize: undefined },
    });
};
//# sourceMappingURL=MuiButton.js.map